export interface IUserHostInviteeResponse {
  Name?: string
  Email?: string
  Status?: HostInviteeStatus
  Access?: HostEventAccessType
  AllowTransferringOwnership?: boolean
  AllowRemovingUser?: boolean
  AllowResendingInvite?: boolean
}

export class UserHostInvitee {
  name?: string
  email?: string
  status?: HostInviteeStatus
  accessLevel?: HostEventAccessType
  canTransferOwnership?: boolean
  canBeRemoved?: boolean
  canBeReinvited?: boolean

  constructor(user: Partial<UserHostInvitee>) {
    this.name = user.name
    this.email = user.email
    this.status = user.status
    this.accessLevel = user.accessLevel
    this.canTransferOwnership = user.canTransferOwnership
    this.canBeRemoved = user.canBeRemoved
    this.canBeReinvited = user.canBeReinvited
  }

  public static fromResponse(response: IUserHostInviteeResponse) {
    return new UserHostInvitee({
      name: response.Name,
      email: response.Email,
      status: response.Status,
      accessLevel: response.Access,
      canTransferOwnership: response.AllowTransferringOwnership,
      canBeRemoved: response.AllowRemovingUser,
      canBeReinvited: response.AllowResendingInvite,
    })
  }
}

export enum HostEventAccessType {
  None = 0,
  Read = 4,
  Upload = 8,
  Write = 16,
  Owner = 32,
  Pro = 64,
  Admin = 128,
}

export enum HostInviteeStatus {
  Invited = 0,
  Active = 1,
}
